export default __webpack_public_path__ + "static/media/010203-1366x668.a6fb792c.jpg";